import axios from './common/axios';
const API_URL = '/labels';

export default {
  get(params, callback) {
    let _params, url;
    if (params && params.label_id) {
      url = `${API_URL}/${params.label_id}`;
      _params = {};
    } else {
      url = API_URL;
      _params = params;
    }

    axios
      .get(url, {
        params: _params
      })
      .then(function(res) {
        if (res.data.status !== 'ok') {
          return callback(new Error(res.data.message));
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err.response));
  },

  post(id, callback) {
    const url = `${API_URL}/${id}`;
    axios
      .post(url)
      .then(function(res) {
        if (res.data.status !== 'ok') {
          return callback(new Error(res.data.message));
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err.response));
  },

  delete(id, callback) {
    const url = `${API_URL}/${id}`;
    axios
      .delete(url)
      .then(function(res) {
        if (res.data.status !== 'ok') {
          return callback(new Error(res.data.message));
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err.response));
  }
};
